export default __webpack_public_path__ + "static/media/MORINGAs.e6b1de76.png";